// extracted by mini-css-extract-plugin
module.exports = {"skltn":"MultiLeadCheckboxes_skltn__1I8uX","acrdn":"MultiLeadCheckboxes_acrdn__v0KAi"};